import { render, staticRenderFns } from "./HubPool.vue?vue&type=template&id=2567e654"
import script from "./HubPool.vue?vue&type=script&lang=js"
export * from "./HubPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports